module.exports = __webpack_public_path__ + "img/broom_handle.b38b22c6.png";